import React from 'react';
import styled from "@emotion/styled";
import { ReactComponent as WhiteLogo} from "../Plain_LTC_Logo_WhiteBG.svg"
import homeImage from "../IMG_1210~2.jpg";

const HomePageContainer = styled("div")({
  backgroundImage: `url(${homeImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  width: '100%',
  minHeight: '100vh',
})

export const HomePage = () => {
    return (
    <HomePageContainer className="App">

      <div className="px-4 py-5 my-5 text-center">
        <div className="col-lg-6 mx-auto">
          <div>
            <WhiteLogo className="d-block mx-lg-auto img-fluid"  />
            <h1>ELEVATE YOUR TAX EXPERIENCE</h1>
            <h2>TAX PREPARATION AND CONSULTING SERVICES IN MORRISON, CO</h2>
          </div>
        </div>
      </div>
  </HomePageContainer>
    )
}
